export default "__VITE_ASSET__6f5d07ca__"